import {Tooltip, Spin} from "antd";
import React, {useEffect, useState} from "react";
import {injectIntl} from "react-intl";
import ImageRemover from "./ImageRemover";
import "./images.scss";
import PermissionCheck from "~Common/PermissionCheck/index.tsx";
import {PermissionOperations} from "~enums/permissions.ts";

const ImageDisplay = (props) => {
    const {
        data,
        images,
        pageRef,
        imageType,
        setRefreshFlag,
        checkQuality,
        permissionKey,
        intl: {formatMessage},
    } = props;
    const [image, setImage] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (images && images.find((image) => image.imageType === imageType)) {
            setImage(images.find((image) => image.imageType === imageType));
        } else {
            setLoading(false);
            setImage(null);
        }
        // eslint-disable-next-line
    }, [JSON.stringify(images)]);

    useEffect(() => {
        if (image) {
            setLoading(true);
            const img = new Image();
            img.src = image.url + "?t=" + new Date().getTime();
            img.onload = () => {
                setLoading(false);
            };
        }
        // eslint-disable-next-line
    }, [image]);

    function composeWarningTitle(image) {
        if (!image) {
            return [];
        }
        const warnings = [];
        if (image.rating === "LOW") {
            warnings.push(
                formatMessage({
                    id: "image.quality.warning",
                    defaultMessage: "Image may lack enough transparency",
                }),
            );
        }
        if (image.maximumHeight * image.maximumWidth < 10e5) {
            warnings.push(
                formatMessage({
                    id: "image.size.warning",
                    defaultMessage: "Recommended image size is a minimum 1000x1000 pixels",
                }),
            );
        }
        return warnings;
    }

    return (
        <div className="inline-image-container">
            {image && (
                <>
                    {loading && <Spin size="default" className="spinner" />}
          {!loading && <img src={image.url} alt={imageType} className="inline-image" />}
          {!loading && checkQuality && composeWarningTitle(image).length > 0 && (
              <Tooltip title={composeWarningTitle(image).join("\n")}>
              <span className="quality-warning">
                <i className="fas fa-exclamation-triangle">
                  <span>Low Quality</span>
                </i>
              </span>
              </Tooltip>
          )}
                    <PermissionCheck permissionKeys={[permissionKey]} permissionOptions={[PermissionOperations.UPDATE]}>
                        <ImageRemover
                            data={data}
                            imageId={image.imageId}
                            pageRef={pageRef}
                            setRefreshFlag={setRefreshFlag}
                            setLoading={setLoading}
                            imageLoading={loading}
                        />
                    </PermissionCheck>
                </>
            )}
        </div>
    );
};

export default injectIntl(ImageDisplay);
